import { DeliveryTypes } from '../../enums/notification/delivery-types';
import { ChannelTypes } from '../../enums/notification/channel-types';
import { NotificationConfigTypes } from '../../types/notification-config-types';
import { EmailNotificationProps } from './email-notification-props';

/**
 * Defines a single notification channel within a NotificationConfig.
 * Channels are processed independently; disabled channels are skipped.
 */
export class Channel {
	/** Channel delivery type. Email=0 (only type currently supported). @default ChannelTypes.Email */
	channelType: ChannelTypes = ChannelTypes.Email;
	/** Channel-specific delivery configuration (e.g. EmailNotificationProps for email channels). */
	channelConfig: NotificationConfigTypes = new EmailNotificationProps();
	/** Display label for this channel configuration. @default '' */
	channelName = '';
	/** Delivery mode. NotificationPerRecord=0 (one notification per flow record), SingleNotification=1 (one notification for all records). @default DeliveryTypes.NotificationPerRecord */
	deliveryType: DeliveryTypes = DeliveryTypes.NotificationPerRecord;
	/** When false, this channel is skipped entirely. @default true */
	enabled = true;
	/** Optional iHub email template ID to use for the message body. */
	emailTemplateId?: string;

	constructor(init?: Partial<Channel>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
